export interface ReplaceHistoryStackEntryAction<
  A extends string = string,
  N = string,
  S = {}
> {
  index?: number;
  name: N;
  state?: S;
  type: A;
}

export const createReplaceHistoryStackEntryActionCreator = <
  A extends string,
  N extends string,
  S
>(
  actionTypePrefix: string,
): ((
  name: N,
  state?: S,
  index?: number,
) => ReplaceHistoryStackEntryAction<A>) => (
  name: N,
  state?: S,
  index?: number,
): ReplaceHistoryStackEntryAction<A, N, S> => ({
  index,
  name,
  state,
  type: (actionTypePrefix + 'REPLACE') as A,
});
